import type { ReactNode } from 'react';

interface Props {
  /** El rótulo diminuto de arriba: DE QUÉ habla esta pantalla. */
  scope?: string;
  title: ReactNode;
  /** Una frase debajo del título. Nunca dos. */
  lede?: ReactNode;
  /** Las acciones de la pantalla, alineadas al final de la línea. */
  actions?: ReactNode;
}

/**
 * El encabezado de una pantalla, con el ritmo de titular del brandbook:
 * rótulo diminuto/extrabold/muy espaciado encima de un título grande y
 * apretado. Es el mismo par `.card__scope` + `.card__title` que canvas usa en
 * cada tarjeta, subido al nivel de la página.
 */
export default function PageHeader({ scope, title, lede, actions }: Props) {
  return (
    <div className="page-head">
      <div className="min-w-0">
        {scope && <span className="brand-label page-head__scope">{scope}</span>}
        <h1 className="page-head__title">{title}</h1>
        {lede && <p className="page-head__lede">{lede}</p>}
      </div>
      {actions && <div className="page-head__actions">{actions}</div>}
    </div>
  );
}
